module.exports = __webpack_public_path__ + "static/media/linkedin-logo.038f5513.svg";